import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import { ReactComponent as TimeSVG } from './assets/Time.svg';
import { ReactComponent as BalanceSVG } from './assets/balance.svg';
import { useStyles } from './styles';
import { useAppDispatch } from '../../../store';
import { useAppConfiguration } from '../../shared/hook';
import { addSectionInfo } from '../../../store/common';

const MentorsPageHeader: FC = () => {
  const { t } = useTranslation();
  const { withUnlimitedCredits } = useAppConfiguration();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const onLearnMore = () => {
    dispatch(addSectionInfo({ sectionInfo: 'mentors' }));
  };

  return (
    <Box className={classes.videoCallDetails}>
      <Typography variant="h2">
        {t('v2.mentorOverview.header_label_title')}
      </Typography>
      <Box className={classes.descriptionWrapper}>
        <Typography component="p">
          {t('v2.mentorOverview.header_label_subtitle')}
          <Typography
            component="span"
            variant="body1"
            className={classes.learnMore}
            onClick={onLearnMore}
          >
            {` ${t('v2.global.button_label_learnMore')}`}
          </Typography>
        </Typography>
      </Box>
      <Box>
        <Typography variant="body1" className={classes.callInfo}>
          {t('v2.mentorOverview.header_label_videoCallDetails')}
        </Typography>
        <Box className={classes.iconsContainer}>
          <Typography
            component="span"
            variant="body1"
            className={classes.iconWrapper}
          >
            <TimeSVG className={classes.icon} />
          </Typography>
          <Typography
            component="span"
            variant="body1"
            style={{ fontWeight: 700 }}
          >
            45 mins
          </Typography>
          {!withUnlimitedCredits && (
            <>
              <Typography
                component="span"
                variant="body1"
                className={classes.iconWrapper}
                style={{ paddingLeft: 32 }}
              >
                <BalanceSVG className={classes.icon} />
              </Typography>
              <Typography
                component="span"
                variant="body1"
                style={{ fontWeight: 700 }}
              >
                {t('v2.global.label_credits', { count: 3 })}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MentorsPageHeader;
